@import (reference) "../../../../../../src/VX/Asset/Less/Base/01-settings/globals.less";
@import (reference) "../../../../../../src/VX/Asset/Less/VX/02-tools/mixins";

.tile__model {
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: @font-weight-bold;
  position: absolute;
  top: 8px;
  left: 8px;
  text-shadow: 0px 0px 6px rgba(0, 0, 0, 0.9);
  color: white;
  .cursor-pointer();
}

.tile__model-image {
  object-fit: cover;
  border-radius: 50%;

  &.-sm {
    width: 16px;
    height: 16px;
  }

  &.-md {
    width: 24px;
    height: 24px;
  }

  &.-lg {
    width: 30px;
    height: 30px;
  }
}

.tile__model-image--online {
  border: 2px solid @color-success;
}

.tile__model-image--videocall {
  border: 2px solid @color-button-videocall;
}

.tile__model-image--offline {
  border: 2px solid @color-fg;
}

.tile__model-name {
  font-family: @font-family-base;
  font-weight: @font-weight-normal;
  font-size: 15px;
}

.tile__badges {
  display: flex;
  bottom: 10px;
  left: 10px;
  position: absolute;
}

.tile_badge {
  border-radius: 2px;
  text-transform: uppercase;
  margin-right: 4px;
  background-color: @color-highlight;
  padding: 3px 4px 2px;
  font-size: 12px;
  font-weight: @font-weight-bold;
  font-family: @font-family-base;
  color: @color-mood-900;
}

.tile_badge-active {
  background-color: @color-success;
  color: @color-mood-900;
}

.tile_badge-videocall {
  background-color: @color-button-videocall;
  color: @color-mood-900;
}

.tile_badge-video-count {
  color: @color-mood-900;
}

.actor-plate__lang-wrapper {
  display: flex;
  position: absolute;
  top: 10px;
  right: 10px;
  gap: 5px;
}

.actor-plate__lang-item {
  width: 18px;
  height: 18px;
}

.actor-plate__lang {
  display: inline-block;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.button-wrapper {
  position: absolute;
  right: 10px;
  bottom: 10px;
}

.tile__image-wrapper {
  display: contents;
}
